import { VideoPlayer } from '@components/common'
import conf from '@configuration'
import { Product, ProductItem } from '../../../types/rest'
import React, { useCallback, useRef } from 'react'
import useMediaQuery from '../../../hooks/useMediaQuery'
import { small } from '../../../constants'
import styled from 'styled-components'
import { VideoJsPlayer } from 'video.js'
import Cross from '../../../images/icons/cross.svg'
import {logger} from "@helpers";

type Props = {
  product: Product
  selectedItem?: ProductItem
  setPlayTrailer: React.Dispatch<React.SetStateAction<boolean>>
}
// Componente per visualizzare il trailer del prodotto, si vede premendo sul tasto |> trailer
const CourseShowTrailer: React.FC<Props> = ({ product, selectedItem, setPlayTrailer }) => {
  const videoPlayer = useRef<VideoJsPlayer | null>(null)

  const isMobile = useMediaQuery(`(max-width: ${small})`)

  const stopPlayingTrailer = useCallback(() => setPlayTrailer(false), [setPlayTrailer])

  const onPlayerReady = useCallback(
    (vp: any) => {
      if(!vp) return
      videoPlayer.current = vp
      vp.addEventListener('error', logError)
      if (vp.currentTime === 0) {
        vp.currentTime = selectedItem?.time || 0
      }
      vp.addEventListener('ended', stopPlayingTrailer)
      const controlBar = (document.querySelector('#left-controls') as any)
      if (controlBar && !document.getElementById('custom')) {
        // aggiunta bottone per l'apertura della struttura del corso
        const button = document.createElement("button")
        // inserisce il bottone prima del tasto play/pause
        controlBar.insertBefore(button, controlBar.firstChild)

        const structureEl = button as HTMLButtonElement
        structureEl.innerHTML = `<img id='custom' alt="cross" src="${Cross}" style="height: 50%;"/>`
        structureEl.style.cursor = 'pointer'
        structureEl.style.height = 'var(--player-icons-height)'
        structureEl.style.width = 'var(--player-icons-height)'
        structureEl.onclick = () => {
          setPlayTrailer(false)
        }
      }
    },
    [selectedItem, setPlayTrailer, stopPlayingTrailer]
  )

  const onPlayerDispose = useCallback((vp: any) => {
    if(!vp) return
    vp.removeEventListener('error', logError)
    vp.removeEventListener('ended', stopPlayingTrailer)
  }, [stopPlayingTrailer])

  if (selectedItem?.video?.url || product.trailer !== null) {
    return (
      <VideoContainer isMobile={isMobile}>
        <VideoPlayer
          entityName={'trailers'}
          onPlayerReady={onPlayerReady}
          isInline={true}
          onPlayerDispose={onPlayerDispose}
          setPlayInline={()=>setPlayTrailer(prev => !prev)}
          options={{
            controls: true,
            muted: false,
            fill: true,
            autoplay: true,
            inactivityTimeout: 4000,
            sources: [
              {
                src: `${conf.wowzaUrl}${(product as Product).trailer}${conf.wowzaOption}`
              }
            ]
          }}
          style={{
            margin: '0',
            height: isMobile ? '22rem' : '100%',
            aspectRatio: '16 / 9',
            width: '100%'
          }}
          poster={product.thumbnail}
        />
      </VideoContainer>
    )
  } else {
    return null
  }
}

export default CourseShowTrailer

const logError = (evt: any) => {
  logger.error(evt)
}

//region Style

const VideoContainer = styled.div<{ isMobile: boolean }>`
  height: ${(props) => (props.isMobile ? '22rem' : 'auto')};
  width: 100%;
  max-width: 99vw;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  & > img {
    flex-shrink: 0;
    min-width: 100%;
    min-height: 100%;
  }
`

//endregion
